// Load jquery for the full page.
window.$ = window.jQuery = require('jquery').noConflict();
